import React, { useCallback, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

//ReactDOM.render(
//  <BrowserRouter>
//    <App />
//  </BrowserRouter>,
//  document.getElementById('root')
//);
  
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong. Please reload.</h1>;
    }
    return this.props.children; 
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    // <BrowserRouter basename="/_car/_r/ecu-helper">
    <BrowserRouter>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>,
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
